document.addEventListener('DOMContentLoaded', function() {

  // ── HAMBURGER MENU ──────────────────────────────────────────────
  var ham  = document.getElementById('sndt-ham');
  var menu = document.getElementById('sndt-mobile-menu');
  if (ham && menu) {
    var links = menu.querySelectorAll('a');
    function closeMenu() {
      ham.classList.remove('open');
      menu.classList.remove('open');
      ham.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }
    ham.addEventListener('click', function() {
      var open = menu.classList.toggle('open');
      ham.classList.toggle('open');
      ham.setAttribute('aria-expanded', String(open));
      document.body.style.overflow = open ? 'hidden' : '';
    });
    links.forEach(function(l) { l.addEventListener('click', closeMenu); });
  }

  // ── SCROLL REVEAL ───────────────────────────────────────────────
  var revs = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window) {
    var obs = new IntersectionObserver(function(entries) {
      entries.forEach(function(e) {
        if (e.isIntersecting) e.target.classList.add('in');
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -24px 0px' });
    revs.forEach(function(el) { obs.observe(el); });
  } else {
    revs.forEach(function(el) { el.classList.add('in'); });
  }

  // ── DONATION POPUP ──────────────────────────────────────────────
  var overlay    = document.getElementById('sndt-donate-overlay');
  var cfg        = document.getElementById('sndt-donate-cfg');
  var closeBtn   = document.getElementById('sndt-donate-close');
  var skipBtn    = document.getElementById('sndt-donate-skip');
  var donateBtn  = document.getElementById('sndt-donate-btn');
  var customInp  = document.getElementById('sndt-custom-amount');

  if (overlay && cfg) {
    var delay    = (parseInt(cfg.dataset.delay, 10) || 8) * 1000;
    var baseLink = cfg.dataset.link || '#';
    var SESSION_KEY = 'sndt_donate_dismissed';

    function wasDismissed() {
      try { return sessionStorage.getItem(SESSION_KEY); } catch(e) { return false; }
    }
    function dismiss() {
      try { sessionStorage.setItem(SESSION_KEY, '1'); } catch(e) {}
      overlay.classList.remove('visible');
      setTimeout(function() { overlay.hidden = true; }, 400);
    }
    function showPopup() {
      if (wasDismissed()) return;
      overlay.hidden = false;
      requestAnimationFrame(function() {
        requestAnimationFrame(function() {
          overlay.classList.add('visible');
        });
      });
    }

    // Fire after delay
    setTimeout(showPopup, delay);

    // Amount buttons
    document.querySelectorAll('.sndt-donate-amt').forEach(function(btn) {
      btn.addEventListener('click', function() {
        document.querySelectorAll('.sndt-donate-amt').forEach(function(b) {
          b.classList.remove('selected');
        });
        btn.classList.add('selected');
        if (customInp) customInp.value = '';
        updateLink(btn.dataset.amount);
      });
    });

    // Custom amount input
    if (customInp) {
      customInp.addEventListener('input', function() {
        document.querySelectorAll('.sndt-donate-amt').forEach(function(b) {
          b.classList.remove('selected');
        });
        updateLink(customInp.value);
      });
    }

    function updateLink(amt) {
      if (!donateBtn) return;
      if (amt && parseFloat(amt) > 0) {
        var sep = baseLink.indexOf('?') > -1 ? '&' : '?';
        donateBtn.setAttribute('href', baseLink + sep + 'amount=' + encodeURIComponent(amt));
      } else {
        donateBtn.setAttribute('href', baseLink);
      }
    }

    // Close handlers
    if (closeBtn) closeBtn.addEventListener('click', dismiss);
    if (skipBtn)  skipBtn.addEventListener('click', dismiss);
    overlay.addEventListener('click', function(e) {
      if (e.target === overlay) dismiss();
    });
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && !overlay.hidden) dismiss();
    });
  }

});